import { render, staticRenderFns } from "./hotelDetail.vue?vue&type=template&id=af59d86e&scoped=true"
import script from "./hotelDetail.vue?vue&type=script&lang=js"
export * from "./hotelDetail.vue?vue&type=script&lang=js"
import style0 from "./hotelDetail.vue?vue&type=style&index=0&id=af59d86e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af59d86e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af59d86e')) {
      api.createRecord('af59d86e', component.options)
    } else {
      api.reload('af59d86e', component.options)
    }
    module.hot.accept("./hotelDetail.vue?vue&type=template&id=af59d86e&scoped=true", function () {
      api.rerender('af59d86e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/directPurchaseSpecialPrice/directSendChild/hotelDetail.vue"
export default component.exports